import { FC } from 'react';
import { IImageTextSideBySideBladeProps } from 'blades/ImageTextSideBySideBlade/@types';
import Button, { ThemeType } from '../Button';
import ImageComponent from '../Image';
import RichText from '../RichText';
import SectionWrapper from '../SectionWrapper';
import Typo from '../Typo';
import { useIsMobileViewport } from '../../hooks/useIsMobileViewport';
import styles from './imageTextSideBySide.module.sass';

const ImageTextSideBySide: FC<IImageTextSideBySideBladeProps> = ({
  title,
  description,
  mediaDirection,
  buttonLink,
  image,
  backgroundColor,
  separator,
}) => {
  const { isMobile } = useIsMobileViewport();
  const isMediaLeft = mediaDirection === 'Left';

  return (
    <SectionWrapper backgroundColor={backgroundColor}>
      <div className={`${styles.sideBySideContainer} ${separator ? styles.separator : ''}`}>
        {isMediaLeft && <ImageComponent image={image} width={isMobile ? '90%' : '500px'} />}
        <div className={styles.sideBySideContent}>
          <Typo h2 classes={styles.sideBySideTitle}>
            {title}
          </Typo>
          <RichText document={description} classes={styles.sideBySideDescription} />
          {buttonLink && (
            <Button
              isBtn={!!buttonLink}
              theme={buttonLink?.fields.layout as ThemeType}
              link={buttonLink}
              classes={styles.sideBySideButton}
            />
          )}
        </div>
        {!isMediaLeft && <ImageComponent image={image} width={isMobile ? '90%' : '500px'} />}
      </div>
    </SectionWrapper>
  );
};

export default ImageTextSideBySide;
